module.exports = __webpack_public_path__ + "img/safedig_logo_color-01.889afce6.png";